import React, { useState } from 'react';
import { Heart, ShoppingBag } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * Template 20: BAZAAR — Marketplace Vibrant
 * ProductCard: White card, magenta "HOT" badge, rounded-2xl, playful hover with rotation
 */
const ProductCard20 = ({ product, index = 0 }) => {
    const navigate = useNavigate();
    const [wishlisted, setWishlisted] = useState(false);
    const [hovered, setHovered] = useState(false);

    const handleWishlist = (e) => {
        e.stopPropagation();
        setWishlisted(!wishlisted);
    };

    const handleAddToCart = (e) => {
        e.stopPropagation();
    };

    return (
        <div
            onClick={() => navigate(`/template20/product/${product.id}`)}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className="group cursor-pointer bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500"
            style={{
                transform: hovered ? 'translateY(-8px) rotate(-0.5deg)' : 'translateY(0) rotate(0)',
                transition: 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94), box-shadow 0.4s ease',
            }}
        >
            {/* Image Container */}
            <div className="relative aspect-[3/4] overflow-hidden bg-[#FDF4FF]">
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                    loading="lazy"
                />

                {/* HOT Badge */}
                {product.badge && (
                    <div className="absolute top-3 left-3 bg-[#C026D3] text-white text-[10px] sm:text-xs font-bold px-3 py-1 rounded-full shadow-lg"
                        style={{ fontFamily: "'Rubik', sans-serif" }}>
                        {product.badge}
                    </div>
                )}

                {/* Discount Badge */}
                {product.originalPrice && (
                    <div className="absolute top-3 right-12 bg-[#FF6B6B] text-white text-[10px] sm:text-xs font-bold px-2 py-1 rounded-full">
                        {Math.round((1 - product.price / product.originalPrice) * 100)}% OFF
                    </div>
                )}

                {/* Wishlist Button */}
                <button
                    onClick={handleWishlist}
                    className="absolute top-3 right-3 w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-md transition-all duration-300 hover:scale-110"
                >
                    <Heart
                        className={`w-4 h-4 transition-colors duration-300 ${wishlisted ? 'fill-[#C026D3] text-[#C026D3]' : 'text-gray-400'}`}
                    />
                </button>

                {/* Quick Add to Cart - Appears on Hover */}
                <div
                    className="absolute bottom-0 left-0 right-0 p-3 transition-all duration-300"
                    style={{
                        transform: hovered ? 'translateY(0)' : 'translateY(100%)',
                        opacity: hovered ? 1 : 0,
                    }}
                >
                    <button
                        onClick={handleAddToCart}
                        className="w-full bg-[#C026D3] text-white py-2.5 rounded-xl text-xs sm:text-sm font-semibold flex items-center justify-center gap-2 hover:bg-[#A21CAF] transition-colors duration-300"
                        style={{ fontFamily: "'Nunito', sans-serif" }}
                    >
                        <ShoppingBag className="w-4 h-4" />
                        Add to Bag
                    </button>
                </div>
            </div>

            {/* Product Info */}
            <div className="p-3 sm:p-4">
                {product.category && (
                    <p className="text-[10px] sm:text-xs text-[#C026D3] font-semibold uppercase tracking-wider mb-1"
                        style={{ fontFamily: "'Nunito', sans-serif" }}>
                        {product.category}
                    </p>
                )}
                <h3
                    className="text-sm sm:text-base font-semibold text-[#1A1A1A] mb-1.5 line-clamp-1"
                    style={{ fontFamily: "'Rubik', sans-serif" }}
                >
                    {product.name}
                </h3>
                <div className="flex items-center gap-2">
                    <span className="text-base sm:text-lg font-bold text-[#1A1A1A]" style={{ fontFamily: "'Rubik', sans-serif" }}>
                        {typeof product.price === 'number' ? `\u20B9${product.price.toLocaleString('en-IN')}` : product.price}
                    </span>
                    {product.originalPrice && (
                        <span className="text-xs sm:text-sm text-[#6B7280] line-through">
                            {typeof product.originalPrice === 'number' ? `\u20B9${product.originalPrice.toLocaleString('en-IN')}` : product.originalPrice}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCard20;
